const dashboard = {
  dashboard: {
    welcome: "欢迎回来",
    subtitle: "您的紫微斗数分析和工具",
    recentResults: "最近结果",
    myChart: "查看我的紫微斗数",
    calculateForOthers: "为他人计算",
    learningResources: "学习资源",
    upcomingEvents: "即将到来的活动",
    viewChart: "查看星图",
    newCalculation: "新建计算",
    exploreResources: "探索资源",
    noResults: "暂无结果",
    startCalculating: "从创建新的星图计算开始",
    viewYourChart: "查看和分析您的个人紫微斗数星图",
    createChartForOthers: "为朋友、家人或客户创建并保存星图",
    accessResources: "访问教育内容和参考资料",
    noEvents: "暂无即将举行的活动",
    checkBackLater: "稍后查看计划的活动和课程",
    viewAll: "查看全部",
    viewNow: "立即查看",
    startNow: "立即开始",
    explore: "探索",
    register: "报名参加",
    quickActions: "快捷操作",
    popularResources: "热门资源",
    updatedAgo: "{{time}}前更新",
    savedProfiles: "{{count}}个已保存档案",
    newBadge: "新",
    resourceLinks: {
      basics: "紫微斗数基础入门",
      palaceSystem: "十二宫位系统详解",
      starTypes: "主星解析与影响"
    },
    actions: {
      myChart: {
        title: "我的星盘",
        description: "查看您的个人紫微斗数星盘"
      },
      calculate: {
        title: "计算",
        description: "为他人生成星盘"
      }
    },
    table: {
      name: "姓名",
      date: "日期",
      type: "类型",
      action: "操作",
      view: "查看",
      delete: "删除",
      gender: "性别",
      male: "男",
      female: "女",
      self: "自己",
      other: "他人"
    },
    deleteConfirmTitle: "删除档案",
    deleteConfirmMessage: "您确定要删除 \"{{name}}\" 吗？此操作无法撤销。",
    deleteSuccess: "档案 \"{{name}}\" 已成功删除。",
    deleteError: "删除档案失败。请重试。",
    emptyState: {
      title: "暂无结果",
      description: "从创建新的星盘计算开始。",
      action: "新建计算"
    }
  },
};

export default dashboard; 